// Holds the tab content area at the previous tab's height while the new tab loads, so the
// page doesn't shrink and regrow (and jump the scroll) when switching Map / Counter / Charts.
import { useEffect, useLayoutEffect, useRef, useState } from 'react';

const HOLD_MS = 900;

export default function SectionStage({ section, children }) {
  const ref = useRef(null);
  const lastHeight = useRef(0);
  const [minHeight, setMinHeight] = useState(0);

  // Remember the content height as it changes
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return undefined;
    const ro = new ResizeObserver(([entry]) => {
      lastHeight.current = entry.contentRect.height;
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  // On a tab switch, hold the old height until the new content has had time to arrive
  useLayoutEffect(() => {
    if (!lastHeight.current) return undefined;
    setMinHeight(lastHeight.current);
    const t = setTimeout(() => setMinHeight(0), HOLD_MS);
    return () => clearTimeout(t);
  }, [section]);

  return (
    <div ref={ref} className="rx-stage" style={minHeight ? { minHeight } : undefined}>
      {children}
    </div>
  );
}
